// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2ZAvb","rotateAnimation":"Loading_rotateAnimation__zSLlp","loadingWrapper":"Loading_loadingWrapper__twz_t"};